export const SUBSTRUCTURE_MATERIAL_CODE_ALUMINIUM = "aluminium";
export const SUBSTRUCTURE_MATERIAL_CODE_TIMBER = "timber";
export const SUBSTRUCTURE_MATERIAL_CODE_WPC = "wpc";

export const SUBSTRUCTURE_MATERIAL_CODES = [
  SUBSTRUCTURE_MATERIAL_CODE_ALUMINIUM,
  SUBSTRUCTURE_MATERIAL_CODE_TIMBER,
  SUBSTRUCTURE_MATERIAL_CODE_WPC,
] as const;

export type KnownSubstructureMaterialCode = (typeof SUBSTRUCTURE_MATERIAL_CODES)[number];

export type SubstructureMaterial = {
  code: string;
  name: string;
  nameIt: string | null;
  nameDe: string | null;
  nameFr: string | null;
  nameEs: string | null;
  image: string | null;
};

// User side (settings, saved configuration): name already in the user's language.
export type SubstructureMaterialForSettings = Omit<SubstructureMaterial, "nameIt" | "nameDe" | "nameFr" | "nameEs">;

export type SearchSubstructureMaterialsResponse = {
  items: SubstructureMaterial[];
  total: number;
};

// export type InsertSubstructureMaterialBody = {
//   name: string;
//   nameIt: string | null;
//   nameDe: string | null;
//   nameFr: string | null;
//   nameEs: string | null;
// };

export type UpdateSubstructureMaterialBody = Omit<SubstructureMaterial, "code"> & {
  removeImage?: boolean;
};
